import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = { class: "text-left" }
const _hoisted_4 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_flex = _resolveComponent("v-flex")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_flex, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { "no-gutters": "" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createElementVNode("h1", null, _toDisplayString("Code NAF (APE)"), -1)
                ])),
                _: 1
              }),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: _ctx.search,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
                    "append-inner-icon": "$search",
                    clearable: "",
                    label: "Recherche",
                    "single-line": "",
                    "hide-details": ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, { "no-gutters": "" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, { class: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_data_table, {
                    headers: _ctx.headers,
                    items: _ctx.items,
                    class: "table",
                    "fixed-header": "",
                    "max-height": "60vh"
                  }, {
                    item: _withCtx((props) => [
                      _createElementVNode("tr", {
                        onClick: ($event: any) => (
                                    _ctx.$router.push({
                                        name: `companyactivity-details`,
                                        params: { id: `${props.item.id}` },
                                    })
                                ),
                        style: {"cursor":"pointer"}
                      }, [
                        _createElementVNode("td", _hoisted_2, _toDisplayString(props.item.name), 1),
                        _createElementVNode("td", _hoisted_3, _toDisplayString(props.item.description), 1),
                        _createElementVNode("td", _hoisted_4, [
                          _createVNode(_component_v_btn, {
                            class: "v-btn-text-white",
                            size: "small"
                          }, {
                            default: _withCtx(() => _cache[2] || (_cache[2] = [
                              _createTextVNode(" Edition ")
                            ])),
                            _: 1
                          })
                        ])
                      ], 8, _hoisted_1)
                    ]),
                    _: 1
                  }, 8, ["headers", "items"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}